import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./imgs/logo_white.svg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import learn from "./imgs/fluent-emoji_brain.png";
import company from "./imgs/fluent-emoji_office-building.png";
import collaboration from "./imgs/fluent-emoji_handshake.png";

function Header() {
  const [showResources, setShowResources] = useState(false);
  const headerRef = useRef(null);
  let location = useLocation();
  useEffect(() => {
    window.onscroll = () => {
      if (window.scrollY > 100) {
        headerRef.current.classList.add("scrolled");
      } else {
        headerRef.current.classList.remove("scrolled");
      }
    };
    window.onclick = (e) => {
      if (headerRef.current.contains(e.target) === false) {
        setShowResources(false);
      }
    };
  }, []);

  // useEffect(() => {
  //   if (!showResources) {
  //     document.body.style.overflow = "auto";
  //   } else {
  //     document.body.style.overflow = "hidden";
  //   }
  // }, [showResources]);

  const handleOpenResources = () => {
    setShowResources(!showResources);
  };

  const isLandingPage = location.pathname === "/";

  return (
    <>
      <div className="site_header" ref={headerRef}>
        <div className="container-fluid">
          <div className="header_wrapper">
            <Link className="site_logo" to={"/"}>
              <img src={Logo} alt="Logo" />
            </Link>
            <div>
              <div className={`resource_link`} onClick={handleOpenResources}>
                RESOURCES
                {showResources ? (
                  <span>
                    <ArrowDropUpIcon />
                  </span>
                ) : (
                  <span>
                    <ArrowDropDownIcon />
                  </span>
                )}
              </div>
              <Link
                to={"https://app.streamfog.com/"}
                target="_blank"
                rel="noopener noreferrer"
                className="ms-5"
                style={{ visibility: isLandingPage ? "hidden" : "visible" }}
              >
                <span className="launch_app">LAUNCH APP</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
      {showResources && (
        <div className="resources">
          <div className="sub-menu">
            <h2 className="sub-menu-h">
              {" "}
              <img src={learn} alt="Learn" />
              LEARN
            </h2>
            <Link
              to={"https://app.streamfog.com"}
              target="_blank"
              rel="noopener noreferrer"
              className="image-link"
            >
              Getting Started <p> Log in with Twitch and enjoy our app</p>
            </Link>
            <Link to={"/streamers"}>
              Tutorial <p>Check out how to use our application</p>
            </Link>
            {/* <Link to={"/blog"}>Blog</Link>
            <Link to="/support">Support</Link> */}
          </div>
          <div className="vertical-line"></div>
          <div className="sub-menu">
            <h2 className="sub-menu-h">
              {" "}
              <img src={company} alt="company" /> COMPANY
            </h2>
            {/* <Link to="/">About</Link>
            <Link to="/career">Join the team</Link> */}
            <Link to={"mailto:kev@streamfog.com"}>
              Contact Us <p>Feel free to get in touch with us.</p>
            </Link>
          </div>
          <div className="vertical-line"></div>
          <div className="sub-menu">
            <h2 className="sub-menu-h">
              {" "}
              <img src={collaboration} alt="collaboration" /> COLLABORATION
            </h2>
            <Link to="/artists">
              Artist Guide{" "}
              <p>
                Learn how to make 3D alerts with <b>Streamfog</b>
              </p>
            </Link>
            <Link to="/agencies">
              Agencies <p>Join us for ESports team and Advertisements</p>
            </Link>
            <Link to="/credits">
              Credits{" "}
              <p>
                Our gratitude for those who help us to build <b>Streamfog</b>
              </p>
            </Link>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
